<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'SystemSettingsLayout',
  page: {
    title: 'System Settings',
    meta: [
      {
        name: 'description',
        content: 'System Settings',
      },
    ],
  },
}
</script>
